import React from 'react';

import { HOMEPAGE_GA_TAGS, HOMEPAGE_SECTIONS } from 'Utilities/analytics/analyticsHomePage';

import { Guides } from '../Guides/Guides';

type Props = {
  readonly className?: string;
}

export const GuidesSection = ({ className }: Props) => {
  const onGuidesSectionLoad = (label: string) => HOMEPAGE_GA_TAGS.SECTION_LOADED(HOMEPAGE_SECTIONS.GUIDES, label);
  const onGuidesCTAClick = () => HOMEPAGE_GA_TAGS.GUIDES_EXPLORE_CLICKED();

  return (
    <Guides onCtaClick={onGuidesCTAClick} onLoad={onGuidesSectionLoad} wrapperClassName={className} />
  );
};
